import React from "react";
import { observer, inject } from 'mobx-react';

import Menu from "@material-ui/core/Menu";
import DrawerIcon from "@material-ui/icons/Dehaze";

import PackListsLayout from './layouts/PackListsMenu';
import PacksMenuLayout from "./layouts/PacksMenu";

class LeftHoverMenu extends React.Component {

	componentDidMount = () => {
		// this.props.store.loadPackLists();
		// this.props.store.appStore.initSnackBars();
		// this.props.store.appStore.renderGamification();
	};

	render() {
		let me = this,
			store = this.props.store,
			menu = store.isPacksMenu
				? <PacksMenuLayout store={store} handleListItemClick={store.handleListItemClick} />
				: <PackListsLayout store={store} handleListItemClick={store.handleListItemClick} />

		return (
			<div>
				{!isLoggedInForFirstTimeSession && <DrawerIcon
					className={"menu_button" + (Util.isMainDashboard() ? " main_dashboard" : "")}
					aria-haspopup="true"
					onClick={store.handleDrawerIconClick}
				/>}
				{
					!isLoggedInForFirstTimeSession && <Menu
						PaperProps={{
							className: "left_hover_menu",
						}}
						anchorEl={store.anchorEl}
						keepMounted
						open={Boolean(store.anchorEl)}
						onClose={store.handleMenuClose}
					>
						{menu}
					</Menu>
				}
			</div>
		);
	}
}

export default inject(({ store: appStore }) => ({
	store: appStore.leftHoverMenuStore,
}))(observer(LeftHoverMenu));